import { status } from 'skin/event/status';

const stat = (obj, form, story, data, d, action) => {
	return status.ignore;
};

export default stat;
